import { displayErrors } from "../../Editor/core/Utils";
import { ajaxRequest } from "../../Utils/Ajax/ajax";
import { successToast } from "../../Utils/utils";


export function loadProfile(){
    $(".save-user-profile").on("click", function(){

        const name = $("#name").val()
        const email = $("#email").val()
        
        
        const errors = checkProfileFormForErrors(email, name)

        if (errors.length > 0){
            displayErrors(errors)
            return
        }  

        const url = '/user/data/update'

        const success = function (data){
            successToast("Daten gespeichert", "Erfolg")
        }

        const data = {
            name: name,
            email: email
        }

        ajaxRequest(url, success, data, $(this))

    });
}

function checkProfileFormForErrors(email, name){
    const errors = []
    const re = /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/;

    if (!re.test(email) || email.length < 5){
        errors.push("Bitte gib eine gültige E-Mail-Adresse ein")
    }

    if (name.length < 3){
        errors.push('Bitte gib einen gültigen Vor- und Nachname ein')
    }

    return errors;
}